import React from "react";

const CasinoFilterIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			viewBox="0 0 14 14"
			{...props}
			fill="none">
			<path
				d="M7.95457 9.24371C8.25509 9.62042 8.67406 9.89869 9.15213 10.0391C9.63021 10.1795 10.1432 10.1749 10.6183 10.026C11.0935 9.8771 11.5067 9.59141 11.7996 9.2094C12.0925 8.82739 12.25 8.36844 12.25 7.89755C12.25 7.39139 12.0649 6.92921 11.7642 6.55408L11.7728 6.55139L7.00002 1.16675L2.22727 6.55139L2.23587 6.55408C1.92221 6.94 1.75157 7.41186 1.75 7.89755C1.75 8.36844 1.90759 8.82739 2.20045 9.2094C2.4933 9.59141 2.90658 9.8771 3.38174 10.026C3.85689 10.1749 4.36984 10.1795 4.84791 10.0391C5.32599 9.89869 5.74496 9.62042 6.04547 9.24371L6.52275 8.64601V10.5899C6.52275 11.936 4.13637 11.936 4.13637 11.936C4.00979 11.936 3.8884 11.9833 3.79889 12.0675C3.70938 12.1516 3.6591 12.2657 3.6591 12.3847C3.6591 12.5038 3.70938 12.6179 3.79889 12.702C3.8884 12.7862 4.00979 12.8335 4.13637 12.8335H9.86367C9.99025 12.8335 10.1116 12.7862 10.2012 12.702C10.2907 12.6179 10.3409 12.5038 10.3409 12.3847C10.3409 12.2657 10.2907 12.1516 10.2012 12.0675C10.1116 11.9833 9.99025 11.936 9.86367 11.936C9.86367 11.936 7.4773 11.936 7.4773 10.5899V8.64601L7.95457 9.24371Z"
				fill="white"
			/>
		</svg>
	);
};

export default CasinoFilterIcon;
